import { Component, OnInit, EventEmitter, Input, Output, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Observable } from 'rxjs/Observable';

import { Collana } from '../../../models/Collana';
import { BookService } from './../../../services/book.service';

@Component({
  selector: 'app-collana-combo-selector',
  templateUrl: './collana-combo-selector.component.html',
  styleUrls: ['./collana-combo-selector.component.css'],
  providers: [
    BookService,
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CollanaComboSelectorComponent),
      multi: true
    }
  ]
})
export class CollanaComboSelectorComponent implements OnInit {

  items: Observable<any>;
  selected: Collana;
  loading: boolean;

  @Input() placeholder: string;
  @Input() required: boolean = false;
  @Output() notify: EventEmitter<Collana> = new EventEmitter<Collana>();

  constructor(private bookService: BookService) { }

  onChange(e: Collana) {
    this.notify.emit(e);
    this.propagateChange(e);
  }

  set _count(c: number) {
    // console.log('_count', c)
  }

  ngOnInit() {
    this.loading = true;
    this.items = this.bookService.readCollane()
      .map(result => {
        this.loading = false;
        if (result.success) {
          return result.items;
        }
      })
  }

  compareWithFn(o1: Collana, o2: Collana) {
    return o1 && o2 ? o1.codice == o2.codice : false;
  }

  private propagateChange = (_: any) => { };

  public writeValue(obj: Collana) {
    this.items.subscribe(a => {
      if (a) {
        if (obj) {
          this.selected = a.find(p => p.codice == obj.codice);
        }
        this.propagateChange(this.selected);
      }
    })
    // this.loading = true;
    // this.items = this.bookService.readCollane()
    //   .map(result => {
    //     this.loading = false;
    //     if (result.success) {
    //       if (obj) {
    //
    //         this.selected = result.items.find(p => p.codice == obj.codice);
    //       }
    //       return result.items;
    //     }
    //   })
  }

  public registerOnChange(fn: any) {
    this.propagateChange = fn;
  }

  public registerOnTouched() { }
}



// WEBPACK FOOTER //
// ./src/app/components/collana/collana-combo-selector/collana-combo-selector.component.ts